import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../contexts/SettingsContext';

function SocialIcon({ href, label, children }) {
  if (!href) return null;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-8 h-8 flex items-center justify-center text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">
      {children}
    </a>
  );
}

export default function Footer() {
  const { settings, waLink } = useSettings();
  const s = settings.social_links || {};

  return (
    <footer data-testid="site-footer" className="bg-[#1E1C1A] text-[#F6F3EE]">
      <div className="max-w-7xl mx-auto px-5 md:px-12 py-12 md:py-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-8">
          <div className="col-span-2 md:col-span-1 mb-4 md:mb-0">
            <h3 className="font-['Cormorant_Garamond'] text-2xl md:text-3xl font-light tracking-[0.3em] mb-4">KIRAQ</h3>
            <p className="text-xs font-light leading-relaxed text-[#F6F3EE]/50 max-w-xs mb-5">
              Designed to elevate your everyday.
            </p>
            {/* Social Icons */}
            <div data-testid="footer-social-icons" className="flex items-center gap-1">
              {s.instagram && (
                <SocialIcon href={s.instagram} label="Instagram">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1"/></svg>
                </SocialIcon>
              )}
              {s.facebook && (
                <SocialIcon href={s.facebook} label="Facebook">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                </SocialIcon>
              )}
              {s.pinterest && (
                <SocialIcon href={s.pinterest} label="Pinterest">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 12a4 4 0 1 1 8 0c0 4-3 6-3 6"/><path d="M9.5 16.5l-1 4.5"/><circle cx="12" cy="12" r="10"/></svg>
                </SocialIcon>
              )}
              {s.youtube && (
                <SocialIcon href={s.youtube} label="YouTube">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19.1c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/></svg>
                </SocialIcon>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-[10px] font-medium uppercase tracking-[0.2em] mb-4 text-[#C6A978]">Shop</h4>
            <ul className="space-y-2">
              <li><Link to="/shop" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">All Pieces</Link></li>
              <li><Link to="/collection/pearl-edit" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">Pearl Edit</Link></li>
              <li><Link to="/collection/gold-edit" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">Gold Edit</Link></li>
              <li><Link to="/collection/after-hours" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">After Hours</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-medium uppercase tracking-[0.2em] mb-4 text-[#C6A978]">Info</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">About</Link></li>
              <li><Link to="/shipping" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">Shipping</Link></li>
              <li><Link to="/terms" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">Terms</Link></li>
              <li><Link to="/faq" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-medium uppercase tracking-[0.2em] mb-4 text-[#C6A978]">Connect</h4>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">Contact</Link></li>
              <li><a href={waLink()} target="_blank" rel="noopener noreferrer" className="text-xs font-light text-[#F6F3EE]/50 hover:text-[#F6F3EE] transition-colors">WhatsApp</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F6F3EE]/10 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[10px] text-[#F6F3EE]/30 tracking-wide">&copy; {new Date().getFullYear()} KIRAQ. All rights reserved.</p>
          <p className="text-[10px] text-[#F6F3EE]/30 tracking-wide italic">Simply Rare</p>
        </div>
      </div>
    </footer>
  );
}
